import type { Question, QuestionStatus } from "../types";
import { asString, asStringArray, parseBoldEntriesV3 } from "./parse-bullets-v3";

// ## Questions (NEW in v0.3)
// Bullet-list entries, same shape as Decisions. Open questions are
// first-class so the reasoning trail starts before the decision lands.

const STATUS_VALUES: ReadonlySet<QuestionStatus> = new Set(["open", "answered", "deferred"]);

export function parseQuestionsV3(body: string): Question[] {
  const entries = parseBoldEntriesV3(body, "Questions");
  return entries.map((entry) => {
    const p = entry.properties;
    const rawStatus = (asString(p.status) ?? "open").toLowerCase();
    const status: QuestionStatus = STATUS_VALUES.has(rawStatus as QuestionStatus)
      ? (rawStatus as QuestionStatus)
      : "open";
    return {
      id: entry.id,
      title: asString(p.title) ?? entry.id,
      status,
      context: asString(p.context),
      candidates: asStringArray(p.candidates),
      blocking: asString(p.blocking),
      owner: asString(p.owner),
      answered_by: asString(p.answered_by),
    };
  });
}
